import { useState, useCallback } from 'react'

export interface DragAndDropState {
    isDragging: boolean
    dragCounter: number
}

export function useDragAndDrop(onFilesDropped: (files: FileList) => void) {
    const [isDragging, setIsDragging] = useState(false)
    const [, setDragCounter] = useState(0)

    const handleDragEnter = useCallback((e: React.DragEvent) => {
        e.preventDefault()
        e.stopPropagation()

        setDragCounter(prev => prev + 1)

        if (e.dataTransfer.items && e.dataTransfer.items.length > 0) {
            setIsDragging(true)
        }
    }, [])

    const handleDragLeave = useCallback((e: React.DragEvent) => {
        e.preventDefault()
        e.stopPropagation()

        setDragCounter(prev => {
            const newCounter = prev - 1
            if (newCounter === 0) {
                setIsDragging(false)
            }
            return newCounter
        })
    }, [])

    const handleDragOver = useCallback((e: React.DragEvent) => {
        e.preventDefault()
        e.stopPropagation()
    }, [])

    const handleDrop = useCallback((e: React.DragEvent) => {
        e.preventDefault()
        e.stopPropagation()

        setIsDragging(false)
        setDragCounter(0)

        const files = e.dataTransfer.files
        if (files && files.length > 0) {
            onFilesDropped(files)
        }
    }, [onFilesDropped])

    return {
        isDragging,
        handlers: {
            onDragEnter: handleDragEnter,
            onDragLeave: handleDragLeave,
            onDragOver: handleDragOver,
            onDrop: handleDrop
        }
    }
}
